'use strict';

var DemandAdjustmentChartController = function DemandAdjustmentChartController($scope) {
  $scope.chartFormatters = {
    xAxisTickFormatter: function xAxisTickFormatter(d) {
      return d;
    },
    yAxisTickFormatter: function yAxisTickFormatter(d) {
      return d * 100;
    }
  };
  $scope.isUserData = function (propertyName) {
    return propertyName === 'user';
  };
  $scope.isWideBarMode = function () {
    return $scope.current.chart === 'demand-adjustment-time-of-day';
  };
};
DemandAdjustmentChartController.$inject = ['$scope'];
module.exports = DemandAdjustmentChartController;